import styled from "styled-components";

export const UploadFileStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    
    .drag-and-drop {
      width: 100%;
      background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
      box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
      border-radius: 11px;
      cursor: pointer;
      color: rgba(55, 54, 71, 0.7);
    
      .drag-and-drop-field {
        margin: 40px auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    
        .field-title {
          color: var(--bllink-gray);
          margin: 20px 0 5px;
        }
      }
    }
    
    .files-list {
      display: flex;
      flex-direction: column;
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid var(--bllink-blue);
      box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
      border-radius: 11px;
      width: 100%;
    }
    .link-button {
      color: var(--bllink-purple);
      text-decoration: underline;
      border:none;
      background-color: transparent;
    }
`;
